// extracted by mini-css-extract-plugin
module.exports = {"placeHolderTile":"LensTilePlaceholder_placeHolderTile__tCQ0K"};